// CNS OBJECT EXTENSION
// FOR MODALS
const noop = () => {}
;(({ $ }) => {
    const page = $('#page')
    const overlay = $('#overlay')

    const pageLockedClass = 'page_locked'
    const overlayShownClass = 'overlay_shown'
    const modalShownClass = 'js-modal-shown'
    const triggerActiveClass = 'js-trigger-active'

    CNS.$modals.shownModals = {
        selectors: [],
        triggers: []
    }

    const openModal = (
        selector,
        trigger,
        showOverlay = false,
        lockPage = false,
        zOverlay = 900,
        callback = noop
    ) =>
        new Promise(resolve => {
            const modal = $(selector)

            if (modal) {
                modal.classList.add(modalShownClass)
                CNS.$modals?.shownModals?.selectors?.push(selector)
            }

            if (lockPage && page) {
                page.classList.add(pageLockedClass)
            }

            if (showOverlay && overlay) {
                overlay.classList.add(overlayShownClass)
                overlay.style.zIndex = zOverlay
            }

            if (trigger) {
                trigger.classList.add('js-trigger-active')
                CNS.$modals?.shownModals?.triggers?.push(trigger)
            }
            callback(modal, trigger, overlay)
            resolve()
        })

    const closeModal = (selector, trigger, callback = noop) =>
        new Promise(resolve => {
            const modal = $(selector)

            if (modal) {
                modal.classList.remove(modalShownClass)
                CNS.$modals.shownModals.selectors = CNS.$modals?.shownModals?.selectors.filter(
                    el => el != selector
                )
            }

            if (page) {
                page.classList.remove(pageLockedClass)
            }

            if (overlay) {
                overlay.classList.remove(overlayShownClass)
            }

            if (trigger) {
                trigger.classList.remove(triggerActiveClass)
                CNS.$modals.shownModals.triggers = CNS.$modals.shownModals.triggers.filter(
                    el => el != trigger
                )
            }
            callback(modal, trigger, overlay)
            resolve()
        })

    const closeAllModals = () =>
        new Promise(resolve => {
            const clonedSelectors = [...CNS.$modals.shownModals.selectors]
            clonedSelectors.forEach(selector => closeModal(selector))

            CNS.$modals.shownModals.triggers.forEach(trigger =>
                trigger.classList.remove(triggerActiveClass)
            )

            CNS.$modals.shownModals = {
                selectors: [],
                triggers: []
            }

            if (page) {
                page.classList.remove(pageLockedClass)
            }

            if (overlay) {
                overlay.classList.remove(overlayShownClass)
            }
            closeAllModalsCallback()
            resolve()
        })

    if (overlay) {
        overlay.addEventListener('click', closeAllModals)
    }

    CNS.$modals.openModal = openModal
    CNS.$modals.closeModal = closeModal
    CNS.$modals.closeAllModals = closeAllModals
})(CNS)

const modalSearchOpenerCallback = (modal, trigger, overlay) => {
    if (trigger) {
        trigger.classList.add('search-trigger_active')
    }

    if (modal) {
        const input = modal.querySelector('.search-form__input')
        input.focus()
    }
}

const modalSearchCloserCallback = () => {
    const trigger = document.querySelector('.search-trigger')
    if (trigger) {
        trigger.classList.remove('search-trigger_active')
    }
}

const closeAllModalsCallback = () => {
    modalSearchCloserCallback()
}

;(({ $, $$ }) => {
    // Touch Panel
    const burger = $('#burger')
    if (burger) {
        burger.addEventListener('click', () => {
            if (burger.classList.contains('js-trigger-active')) {
                // close the touch panel
                CNS.$modals.closeModal('#touch-panel', burger)
                console.log('shold close')
            } else {
                // open the touch panel
                CNS.$modals.openModal('#touch-panel', burger, true, true)
                console.log('shold open')
            }
        })
    }

    // Modal Search

    const modalSearchOpener = $('.js-search-trigger-opener')
    if (modalSearchOpener) {
        modalSearchOpener.addEventListener('click', () => {
            CNS.$modals.openModal(
                '#modal-search',
                modalSearchOpener,
                true,
                true,
                900,
                modalSearchOpenerCallback
            )
        })
    }
    const modalSearchCloser = $('.js-search-trigger-closer')
    if (modalSearchCloser) {
        modalSearchCloser.addEventListener('click', () => {
            CNS.$modals.closeModal('#modal-search', null, modalSearchCloserCallback)
        })
    }

    CNS.$fns.openZoomImage = function () {
        CNS.$modals.openModal('#modal-zoom-image', null, true, true, 1500)
    }

    const zoomImageCloser = $('.js-modal-zoom-image-closer')
    if (zoomImageCloser) {
        zoomImageCloser.addEventListener('click', () => {
            CNS.$modals.closeModal('#modal-zoom-image')
        })
    }

    // 
    /**
     * Modal subscribe
     */

    // open func
    CNS.$fns.openSubscribeNewsModal = function() {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-subscribe-news', null, true, true, 1500)
    }

    // close func
    CNS.$fns.closeSubscribeNewsModal = function() {
        CNS.$modals.closeModal('#modal-subscribe-news')
    }

    // open triggers
    const modalSubscribeNewsOpenTriggers = $$('.js-modal-subscribe-news-open-trigger')
    modalSubscribeNewsOpenTriggers.forEach(trigger => {
        if (!trigger) return
        trigger.addEventListener('click', () => {
            CNS.$fns.openSubscribeNewsModal()
        })
    })

    // close triggers
    const modalSubscribeNewsCloseTriggers = $$('.js-modal-subscribe-news-close-trigger')
    modalSubscribeNewsCloseTriggers.forEach(trigger => {
        if (!trigger) return
        trigger.addEventListener('click', () => {
            CNS.$fns.closeSubscribeNewsModal()
        })
    })

    /**
     * Modal inform
     */
    // open func
    let modalInformAutoCloseTimer = null
    const modalInform = $('#modal-inform')
    let modalInformLifespan = modalInform ? parseInt(modalInform.dataset.lifespan) || 3000 : 3000


    CNS.$fns.openInformModal = function() {
        clearTimeout(modalInformAutoCloseTimer)
        CNS.$modals.openModal('#modal-inform', null, true, true, 1500)

        modalInformAutoCloseTimer = setTimeout(() => {
            CNS.$fns.closeInformModal()
        }, modalInformLifespan)
    }

    // close func
    CNS.$fns.closeInformModal = function() {
        clearTimeout(modalInformAutoCloseTimer)
        CNS.$modals.closeModal('#modal-inform')
    }

    // close triggers
    const modalInformCloseTriggers = $$('.js-modal-inform-close-trigger')
    modalInformCloseTriggers.forEach(trigger => {
        if (!trigger) return
        trigger.addEventListener('click', () => {
            CNS.$fns.closeInformModal()
        })
    })

    /**
     * Modal blocked subscription
     */
    CNS.$fns.openBlockedNotifyModal = function() {
        CNS.$modals.openModal('#modal-blocked-notify', null, true, true, 1500)
    }

    CNS.$fns.closeBlockedNotifyModal = function() {
        CNS.$modals.closeModal('#modal-blocked-notify', null)
    }

    // close triggers
    const modalBlockedNotifyTriggers = $$('.js-modal-blocked-notify-close-trigger')
    modalBlockedNotifyTriggers.forEach(trigger => {
        if (!trigger) return
        trigger.addEventListener('click', () => {
            CNS.$fns.closeBlockedNotifyModal()
        })
    })
})(CNS)
